import Grid from '@mui/material/Grid';
import { useWatch } from 'react-hook-form';

import CompleteYourReservation from 'reservations/availabilities/components/CompleteYourReservation';
import type { DinerFieldProps } from 'reservations/availabilities/types';
import { DinerAuthenticationInput } from 'reservations/dinerAccount/components/DinerAuthenticationInput';
import { useDinerAccount } from 'reservations/dinerAccount/hooks/useDinerAccount';
import { useIsSubjectToCancellationFee } from 'reservations/feePolicy/hooks';
import { BookingFields } from 'reservations/form/components/BookingFields';
import { DinerInformationFields } from 'reservations/form/components/DinerInformationFields';
import UpdateReservationButton from 'reservations/form/components/UpdateReservationButton';

export const ModifyFields = ({ handleFormDrawerClose }: DinerFieldProps) => {
  const partySize = useWatch({ name: 'partySize' });
  const { isDinerAccountAuthenticated } = useDinerAccount();
  const shouldAuthenticate =
    useIsSubjectToCancellationFee(partySize) && !isDinerAccountAuthenticated;

  return (
    <>
      <Grid item>
        <CompleteYourReservation />
      </Grid>
      {shouldAuthenticate ? (
        <DinerAuthenticationInput />
      ) : (
        <>
          <Grid container item gap="16px" direction="column">
            <DinerInformationFields />
            <BookingFields />
          </Grid>
          <Grid item>
            <UpdateReservationButton
              handleFormDrawerClose={handleFormDrawerClose}
            />
          </Grid>
        </>
      )}
    </>
  );
};
